import ActionType from 'actions/ActionType'

export default (state = null, action) => {
  switch (action.type) {
    case ActionType.Tasks.RECEIVE_TASK:
      if (
        action.stageIDSelected &&
        action.campaignSelected &&
        action.campaignSelected.stages
      ) {
        const stagesByID = action.campaignSelected.stages.reduce((acc, el) => {
          acc[el.id] = el
          return acc
        }, {})

        const stage = stagesByID[action.stageIDSelected]

        return {
          label: stage.name,
          key: `${stage.id}StageTaskFormSelect`,
          value: stage.id,
        }
      }
      return null
    default:
      return state
  }
}
